// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-bar-clustered';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.656.576v16.848M9 14.04H1.656v3.384H9c.36 0 .576-.288.576-.576v-2.232A.568.568 0 0 0 9 14.04zm0-9.72H1.656v3.384H9c.36 0 .576-.288.576-.576V4.896A.568.568 0 0 0 9 4.32z' />
    <path
      fill='currentColor'
      d='M15.696 10.296H1.656v3.384h14.112c.36 0 .576-.288.576-.576v-2.232c0-.288-.288-.504-.648-.576zM12.312.576H1.656V3.96h10.728c.36 0 .576-.288.576-.576V1.152c0-.288-.288-.576-.648-.576z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
